// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.jahur5Yr9zvxrL {
  margin-bottom: var(--ds-space-075, 6px);
  border-collapse: collapse;
}
.jahur5Yr9zvxrL,
.jahur5Yr9zvxrL tr,
.jahur5Yr9zvxrL td {
  border: none;
}
.jahur5Yr9zvxrL .HHi7xnb0AY2q5T {
  padding-left: var(--ds-space-0, 0);
  font-weight: var(--ds-font-weight-bold, bold);
}
.jahur5Yr9zvxrL .Ndxm9XQJK3I4Kg {
  padding-right: var(--ds-space-0, 0);
  text-align: right;
}
.LkxJ9V2eW6JJs_ {
  text-transform: capitalize;
}
`, ""]);
// Exports
export var table = `jahur5Yr9zvxrL`;
export var label = `HHi7xnb0AY2q5T`;
export var value = `Ndxm9XQJK3I4Kg`;
export var capitalize = `LkxJ9V2eW6JJs_`;
export default ___CSS_LOADER_EXPORT___;
